import React from "react";
import { Link, useParams } from "react-router-dom";
import FooterOne from "../common/footer/FooterOne";
import HeaderOne from "../common/header/HeaderOne";
import BcrumbBannerOne from "../elements/breadcrumb/BcrumbBannerOne";
import CtaLayoutOne from "../component/cta/CtaLayoutOne";
import SectionTitle from "../elements/section-title/SectionTitle";
import ProjectPropOne from "../component/project/itemProp/ProjectPropOne";
import { slugify } from "../utils";
import ServiceData from "../data/service/ServiceMain.json";
import ProjectData from "../data/project/ProjectData.json";
import AboutTwo from "../component/about/AboutTwo";
import ColorSwitcher from "../elements/switcher/ColorSwitcher";
import SEO from "../common/SEO";
import Tilty from "react-tilty";
import CounterUpTwo from "../component/counterup/CounterUpTwo";
import AboutThree from "../component/about/AboutThree";
import ClientOne from "../component/client/ClientOne";
import BcrumbBannerTwo from "../elements/breadcrumb/BcrumbBannerTwo";
import CertificateGridCard from "../component/certificate/CertificateGridCard";
import BreadCrumbOne from "../elements/breadcrumb/BreadCrumbOne";
import ClientSlider from "../component/client/ClientSlider";
import AccreditationsGallery from "../component/AccreditationsGallery/AccreditationsGallery";

const allServiceData = ServiceData;
const getProjectData = ProjectData;

const Certification = () => {
  // const params = useParams();
  // const serviceSlug = params.slug;

  // const getServiceData = allServiceData.filter(data => slugify(data.title) === serviceSlug);
  const detailsService = ServiceData[0];

  return (
    <>
      <SEO title="Service Details" />
      {/* <ColorSwitcher /> */}
      <main className="main-wrapper">
        <HeaderOne />
        {/* <BcrumbBannerTwo
          title="Certifications"
          paragraph="Our certifications demonstrate our commitment to excellence, quality, and reliability in facility management. Stay tuned as we bring you the latest updates on our accreditations and achievements."
          styleClass=""
          mainThumb="/images/banner/leadership.jpg"
          // mainThumb="/images/banner/industry-img.jpg"
        /> */}
        <BreadCrumbOne
          subtitle="Commitment to excellence through globally recognized standards"
          title="Leading with Certified Expertise"
          page="Accreditations"
        />

        <CertificateGridCard />
        <AccreditationsGallery />
        
        <CounterUpTwo />
        <AboutThree />
        <div className="container " style={{ paddingTop: "100px" }}>
          <SectionTitle
            subtitle="Our Clients"
            title="Our valued partners"
            textAlignment="heading-left mb--40"
            textColor=""
          />
        </div>
        {/* // In your page/component: */}
        <ClientSlider
          itemShow={4}
          colSize="col-md-3"
          columnGap="row-35"
          parentClass="your-custom-class"
        />

        {/* <CtaLayoutOne /> */}
        <FooterOne parentClass="" />
      </main>
    </>
  );
};

export default Certification;
